import React, { ReactElement, Fragment } from "react";
import { Link } from "gatsby";
import Nav from "../Nav";
import NavItem from "../NavItem";
import Button from "../Button";
import Head from "../Head";
import {
  ABOUT_V2_HREF,
  CREDITS_V2_HREF,
} from "../../utils/static-page-v2-urls";
import { ALL_SCENARIOS_V2_HREF } from "../../utils/category-navigation";
import "./Header.less";

interface HeaderProps {
  pageTitle: string;
  pageDescription: string;
  pageType?: string;
  image?: string;
  location: any;
}

export default ({
  pageTitle,
  pageDescription,
  pageType,
  location,
  image
}: HeaderProps): ReactElement => {
  return (
    <Fragment>
      <Head
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        pageType={pageType}
        image={image}
        pathName={location.pathname}
      />
      <header>
        <a href={ALL_SCENARIOS_V2_HREF}>
          <h1>Gravity Simulator</h1>
        </a>
        <Nav
          css={{
            border: "none",
            padding: 0,
            backgroundColor: "transparent",
            minWidth: "initial",
            overflow: "hidden"
          }}
        >
          <NavItem active={location.pathname.startsWith("/version-2/scenarios/all")}>
            <Button cssClassName="button">
              <a href={ALL_SCENARIOS_V2_HREF}>
                <span>
                  <i className="fas fa-home fa-2x button" />
                  Home
                </span>
              </a>
            </Button>
          </NavItem>
          <NavItem active={location.pathname.startsWith("/version-2")}>
            <Button cssClassName="button">
              <a href="/version-2/scenarios/all/">
                <span>
                  <i className="fas fa-star-o fa-2x button" />
                  Gravity Simulator Version 2
                </span>
              </a>
            </Button>
          </NavItem>
          <NavItem active={location.pathname === "/changelog"}>
            <Link to="/changelog">
              {" "}
              <Button cssClassName="button">
                <span>
                  <i className="fas fa-history fa-2x button" />
                  Changelog
                </span>
              </Button>
            </Link>
          </NavItem>
          <NavItem active={location.pathname.startsWith("/version-2/about")}>
            <Button cssClassName="button">
              <a href={ABOUT_V2_HREF}>
                <span>
                  <i className="fas fa-info-circle fa-2x button" />
                  About
                </span>
              </a>
            </Button>
          </NavItem>
          <NavItem active={location.pathname.startsWith("/version-2/credits")}>
            <Button cssClassName="button">
              <a href={CREDITS_V2_HREF}>
                <span>
                  <i className="fas fa-glass fa-2x button" />
                  Credits
                </span>
              </a>
            </Button>
          </NavItem>
          <NavItem>
            <Button cssClassName="button">
              <a
                href="https://github.com/TheHappyKoala/Harmony-of-the-Spheres"
                target="blank"
              >
                <span>
                  <i className="fas fa-github fa-2x" />
                  Contribute
                </span>
              </a>
            </Button>
          </NavItem>
          <NavItem active={location.pathname === "/contact"}>
            <Link to="/contact">
              {" "}
              <Button cssClassName="button">
                <span>
                  <i className="fas fa-envelope-open-o fa-2x button" />
                  Contact
                </span>
              </Button>
            </Link>
          </NavItem>
        </Nav>
      </header>
    </Fragment>
  );
};
